import Logo from '@/components/Logo'
import WelcomeScreen from '@/components/WelcomeScreen'
import { useAuth } from '@/hooks/useAuth'
import { useHead } from '@unhead/react'
import { FormEvent, useEffect, useRef, useState } from 'react'
import { Link, Navigate } from 'react-router-dom'

const WELCOME_DURATION_MS = 5200

function Login() {
  const { loggedIn, login, fullName, adminName } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [welcome, setWelcome] = useState(false)
  const [goAdmin, setGoAdmin] = useState(false)
  const enteringRef = useRef(false)

  useHead({
    title: 'Painel administrativo — Bonita FM',
    htmlAttrs: { lang: 'pt-BR' },
  })

  useEffect(() => {
    if (!welcome) return undefined
    const timer = window.setTimeout(() => setGoAdmin(true), WELCOME_DURATION_MS)
    return () => window.clearTimeout(timer)
  }, [welcome])

  if (goAdmin) return <Navigate to="/admin" replace />
  if (loggedIn && !welcome && !enteringRef.current) return <Navigate to="/admin" replace />

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    enteringRef.current = true
    const ok = await login(username, password)
    if (!ok) {
      enteringRef.current = false
      setSubmitting(false)
      setError('Utilizador ou senha incorretos.')
      return
    }
    setWelcome(true)
    setSubmitting(false)
  }

  if (welcome) {
    return <WelcomeScreen name={fullName || adminName || username} />
  }

  return (
    <div className="radio-bg flex min-h-screen items-center justify-center px-4">
      <form onSubmit={onSubmit} className="w-full max-w-md rounded-[28px] bg-white p-8 text-slate-900 shadow-2xl">
        <Logo className="h-20 sm:h-24" />
        <h1 className="mt-4 font-display text-2xl font-black text-[#0b2ea8]">Painel administrativo</h1>
        <p className="mt-1 text-sm text-slate-500">Entre como administrador ou autor para aceder ao painel.</p>
        <label className="mt-6 block text-sm font-semibold" htmlFor="username">Utilizador</label>
        <input
          id="username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2.5"
          autoComplete="username"
          required
        />
        <label className="mt-4 block text-sm font-semibold" htmlFor="password">Senha</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2.5"
          autoComplete="current-password"
          required
        />
        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
        <button type="submit" className="mt-6 w-full rounded-full bg-[#0b2ea8] py-3 font-extrabold text-white" disabled={submitting}>
          {submitting ? 'A entrar...' : 'Entrar'}
        </button>
        <Link to="/" className="mt-4 block text-center text-sm font-semibold text-[#0b2ea8]">
          Voltar ao site
        </Link>
      </form>
    </div>
  )
}

export default Login
